import { Select } from "components/base/Form";
import Page from "components/base/Page";
import SearchBar from "components/base/SearchBar";
import useSearch from "hooks/useSearch";
import { createContext } from "react";
import MarketTimeProductsView from "./markettime";

export const IncProductSearchContext = createContext({});

const ProductsPage = () => {
  const [q, setQ] = useSearch();

  return (
    <Page title="Waboba INC Products" className="h-screen">
      <div className="p-6 flex flex-col overflow-auto space-y-4">
        <div className="flex items-center space-x-3">
          <Select>
            <option value="markettime">Markettime</option>
            {/* <option value="amazon">Amazon</option>
            <option value="shopify">Shopify</option>*/}
          </Select>
          <div className="flex-1">
            <SearchBar
              placeholder="Search Product by Name, Item Number, UPC.."
              value={q}
              onChange={setQ}
            />
          </div>
        </div>

        <div className="card p-0 relative flex-1 overflow-auto">
          <IncProductSearchContext.Provider value={{ q }}>
            <MarketTimeProductsView />
          </IncProductSearchContext.Provider>
        </div>
      </div>
    </Page>
  );
};

export default ProductsPage;
